import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Indicator from "./components/Indicator";

function PreviewIndicatorRoot() {
  const [indicatorRootRef, setIndicatorRootRef] = useState();
  useEffect(() => {
    const indicatorRoot = document.createElement(`div`);
    indicatorRoot.id = `gatsby-preview-indicator`;
    setIndicatorRootRef(indicatorRoot);
    document.body.appendChild(indicatorRoot);
  }, []);

  if (!indicatorRootRef) {
    return null;
  }

  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(Indicator, null), indicatorRootRef);
}

export const wrapRootElement = ({
  element
}) => {
  if (process.env.GATSBY_PREVIEW_INDICATOR_ENABLED === `true`) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, element, /*#__PURE__*/React.createElement(PreviewIndicatorRoot, null));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, element);
  }
};